export type Actions = {
  type: ActionTypes.SelectOption
  value: string
}

export enum ActionTypes {
  SelectOption,
}
